import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { environment } from '@environments/environment';
import { AntecedenteService } from '@services/antecedente.service';
import { ToastService } from '@utils/toast.service';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-no-inhabilitacion',
  imports: [
    CommonModule,
    BackboneComponent,
    BreadcrumbComponent,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    RouterModule,
    InputMaskModule,
    IconFieldModule,
    InputIconModule,
    InputGroupAddonModule,
    InputGroup,
    TooltipModule,
  ],
  templateUrl: './no-inhabilitacion.component.html',
  styleUrl: './no-inhabilitacion.component.scss',
})
export class NoInhabilitacionPage {
  private formBuilder = inject(FormBuilder);
  private toastService = inject(ToastService);
  private antecedenteService = inject(AntecedenteService);

  public apiUrl = environment.app.apiUrl;
  public isSaving = false;

  public list: any = [];
  public searchValue: string | undefined;

  public formUpload = this.formBuilder.group({
    name: [null, Validators.required],
    curp: [null, Validators.required],
    rfc: [null, Validators.required],
  });

  get name() {
    return this.formUpload.get('name');
  }
  set name(value: any) {
    this.name.setValue(value);
  }
  get curp() {
    return this.formUpload.get('curp');
  }
  set curp(value: any) {
    this.curp.setValue(value);
  }
  get rfc() {
    return this.formUpload.get('rfc');
  }
  set rfc(value: any) {
    this.rfc.setValue(value);
  }

  async ngOnInit() {
    await this.refresh();
  }

  refresh = async () => {
    await this.antecedenteService.listNoInhabilitacion().then((response) => (this.list = response));
  };

  generate = async () => {
    this.isSaving = true;

    const myFormData = new FormData();

    myFormData.append('name', this.name.value);
    myFormData.append('curp', this.curp.value);
    myFormData.append('rfc', this.rfc.value);

    await this.antecedenteService
      .generateNoInhabilitacion(myFormData)
      .then(() => {
        this.toastService.success('Constancia generada.');
        this.formUpload.reset();
        this.refresh();
      })
      .catch((err) => {
        this.toastService.error(err.error.data.message || 'Error al generar la constancia.');
      });

    this.isSaving = false;
  };
}
